/* Arjit4Amply: Build Your Perfect Bundle (sections/matre-bundle-builder.liquid),
   ported from the mockup's bundle-builder.js - same quantities/plan state,
   copy, 3-bottle minimum, mobile bar and localStorage memory.
   Prices come from Shopify (data-price-* in the currency's minor units) and
   the bundle price per plan is the real Appstle plan price, not a rate.
   No review dialog (client): the Checkout button adds every chosen
   formula on the chosen plan to the cart, then goes to Shopify checkout. */
(function () {
  var root = document.querySelector('[data-bundle-builder]');
  if (!root) return;

  var KEY = 'matre-custom-bundle-preview';
  var currency = root.dataset.currency || 'SGD';
  var number = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var money = function (cents) {
    return currency + ' ' + number.format(cents / 100);
  };

  var products = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-product]')).map(function (el) {
    return {
      id: el.dataset.bundleProduct,
      name: el.dataset.name,
      variant: Number(el.dataset.variantId),
      price: { once: Number(el.dataset.priceOnce), quarterly: Number(el.dataset.priceQuarterly), monthly: Number(el.dataset.priceMonthly) },
      plan: { quarterly: el.dataset.planQuarterly, monthly: el.dataset.planMonthly },
      el: el
    };
  });

  var quantities = {};
  products.forEach(function (p) {
    quantities[p.id] = 0;
  });
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    products.forEach(function (p) {
      if (Number.isInteger(saved[p.id]) && saved[p.id] >= 0 && saved[p.id] <= 99) quantities[p.id] = saved[p.id];
    });
  } catch (e) {}

  var plan = 'quarterly';
  try {
    var savedPlan = localStorage.getItem(KEY + '-plan');
    if (['quarterly', 'monthly', 'once'].indexOf(savedPlan) > -1) plan = savedPlan;
  } catch (e) {}
  root.querySelector('[name="bundle-plan"][value="' + plan + '"]').checked = true;

  var $ = function (sel) {
    return root.querySelector(sel);
  };
  var unit = function (p) {
    return p.price[plan];
  };
  var count = function () {
    return products.reduce(function (sum, p) {
      return sum + quantities[p.id];
    }, 0);
  };
  var total = function () {
    return products.reduce(function (sum, p) {
      return sum + p.price.once * quantities[p.id];
    }, 0);
  };
  var discounted = function () {
    return products.reduce(function (sum, p) {
      return sum + unit(p) * quantities[p.id];
    }, 0);
  };
  var selected = function () {
    return products.filter(function (p) {
      return quantities[p.id] > 0;
    });
  };
  var bottles = function (n) {
    return n + ' ' + (n === 1 ? 'bottle' : 'bottles');
  };
  var billing = function () {
    return plan === 'once'
      ? 'One-time purchase. No renewal. Shipping calculated at checkout.'
      : money(discounted()) +
          ' billed every ' +
          (plan === 'quarterly' ? '90' : '30') +
          ' days for the ' +
          count() +
          ' bottles selected. Auto-renews; manage or cancel your subscription. Shipping calculated at checkout.';
  };
  var EMPTY =
    '<div class="matre-bundle__empty"><span aria-hidden="true">+</span><p>A little room for your essentials.</p><small>Add a bottle to start building.</small></div>';

  function update(announce) {
    products.forEach(function (p) {
      var input = p.el.querySelector('[data-bundle-quantity]');
      if (document.activeElement !== input) input.value = quantities[p.id];
      p.el.querySelector('[data-bundle-delta="-1"]').disabled = quantities[p.id] === 0;
      p.el.querySelector('[data-bundle-delta="1"]').disabled = quantities[p.id] === 99;
      p.el.classList.toggle('is-selected', quantities[p.id] > 0);
    });
    var n = count();
    $('[data-bundle-selected]').innerHTML = n
      ? selected()
          .map(function (p) {
            var q = quantities[p.id];
            return (
              '<div class="matre-bundle__selected-line"><div><strong>' + p.name + '</strong><span>' + bottles(q) + ' × ' + money(p.price.once) +
              '</span></div><div><strong>' + money(p.price.once * q) + '</strong><button type="button" data-bundle-remove="' + p.id +
              '" aria-label="Remove all ' + p.name + ' bottles">Remove</button></div></div>'
            );
          })
          .join('')
      : EMPTY;
    $('[data-bundle-count]').textContent = bottles(n);
    $('[data-bundle-subtotal]').textContent = money(total());
    $('[data-bundle-mobile-total]').textContent = money(discounted());
    $('[data-bundle-total]').textContent = money(discounted());
    $('[data-bundle-savings]').textContent = '−' + money(total() - discounted());
    $('[data-bundle-billing]').textContent = n ? billing() : 'Your selected quantities will arrive together in each delivery.';
    $('[data-bundle-progress]').textContent =
      n < 3 ? 'Add ' + (3 - n) + ' more ' + (3 - n === 1 ? 'bottle' : 'bottles') + ' to complete your bundle.' : 'Your bundle is ready.';
    $('[data-bundle-mobile-count]').textContent = bottles(n) + ' selected';
    $('[data-bundle-checkout]').disabled = n < 3;
    $('[data-bundle-clear]').disabled = !n;
    if (announce !== false) {
      $('[data-bundle-announcement]').textContent =
        bottles(n) + ' selected. Bundle total ' + money(discounted()) + '. ' + (n < 3 ? 3 - n + ' more bottles needed.' : 'Minimum met.');
    }
    try {
      localStorage.setItem(KEY, JSON.stringify(quantities));
      localStorage.setItem(KEY + '-plan', plan);
    } catch (e) {}
  }

  // Arjit4Amply: Checkout - one /cart/add.js call with every chosen formula
  // on the chosen plan (Appstle selling plan; none for one-time), then
  // straight to Shopify checkout. Items already in the cart stay there.
  function checkout(button) {
    var items = selected().map(function (p) {
      var item = { id: p.variant, quantity: quantities[p.id] };
      if (plan !== 'once' && p.plan[plan]) item.selling_plan = Number(p.plan[plan]);
      return item;
    });
    var error = $('[data-bundle-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    fetch(window.routes.cart_add_url, Object.assign({}, fetchConfig(), { body: JSON.stringify({ items: items }) }))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        products.forEach(function (p) {
          quantities[p.id] = 0;
        });
        update(false);
        window.location.href = '/checkout';
      })
      .catch(function (e) {
        error.textContent = e.message || (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
        error.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  root.addEventListener('click', function (event) {
    var delta = event.target.closest('[data-bundle-delta]');
    if (delta) {
      var id = delta.dataset.product;
      quantities[id] = Math.max(0, Math.min(99, quantities[id] + Number(delta.dataset.bundleDelta)));
      update();
      return;
    }
    var remove = event.target.closest('[data-bundle-remove]');
    if (remove) {
      quantities[remove.dataset.bundleRemove] = 0;
      update();
      root.querySelector('[data-bundle-quantity="' + remove.dataset.bundleRemove + '"]').focus({ preventScroll: true });
      return;
    }
    if (event.target.closest('[data-bundle-clear]')) {
      products.forEach(function (p) {
        quantities[p.id] = 0;
      });
      update();
      return;
    }
    var go = event.target.closest('[data-bundle-checkout]');
    if (go && count() >= 3) checkout(go);
  });

  root.querySelectorAll('[data-bundle-quantity]').forEach(function (input) {
    input.addEventListener('input', function () {
      if (input.value === '' || !input.validity.valid) return;
      quantities[input.dataset.bundleQuantity] = Number(input.value);
      update();
    });
    input.addEventListener('change', function () {
      var n = Number(input.value);
      quantities[input.dataset.bundleQuantity] = Number.isFinite(n) ? Math.max(0, Math.min(99, Math.floor(n))) : 0;
      input.value = quantities[input.dataset.bundleQuantity];
      update();
    });
  });
  root.querySelectorAll('[name="bundle-plan"]').forEach(function (input) {
    input.addEventListener('change', function () {
      plan = input.value;
      update();
    });
  });

  // Arjit4Amply: the mobile bar hides while the summary or the footer is on
  // screen, like the reference.
  var mobileBar = root.querySelector('.matre-bundle__mobile-bar');
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        entry.target.dataset.bundleInView = entry.isIntersecting ? 'true' : 'false';
      });
      mobileBar.classList.toggle('is-hidden', !!document.querySelector('[data-bundle-in-view="true"]'));
    },
    { threshold: 0 }
  );
  observer.observe(root.querySelector('.matre-bundle__summary'));
  var footer = document.querySelector('.footer');
  if (footer) observer.observe(footer);

  update(false);
})();
